import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import ScrollableTabBar from '../../components/ScrollableTabBar';
import { useUser } from '../../userContext';

function SettingsSidebar() {

  const location = useLocation();
  const { pathname } = location;
  const { isAdmin } = useUser();

  const links = [
    { to: '/studio/settings/account', label: 'Account', match: '/settings/account' },
    { to: '/studio/settings/plans', label: 'Credits', match: '/settings/plans' },
    // Users + Workspaces are legacy agency / team features. Admins keep
    // access to the surfaces; the public flow doesn't surface them in v1.
    ...(isAdmin
      ? [
          { to: '/studio/settings/users', label: 'Users', match: '/settings/users' },
          { to: '/studio/settings/workspaces', label: 'Workspaces', match: '/settings/workspaces' },
          { to: '/studio/settings/apps', label: 'Integrations', match: '/settings/apps' },
        ]
      : []),
    { to: '/studio/settings/help', label: 'Get help', match: '/settings/help', separated: true },
  ];

  return (
    <div className="flex flex-col md:block px-3 py-6 border-b md:border-b-0 md:border-r border-[var(--admin-border)] min-w-[15rem] md:space-y-3 overflow-visible">
      {/* Fixed Settings text */}
      <div className="px-2.5 mb-3">
        <div className="text-xs font-semibold gch-text-secondary">
          Settings
        </div>
      </div>

      {/* Scrollable navigation with edge-fade on mobile */}
      <ScrollableTabBar className="md:static" innerClassName="overflow-visible md:overflow-visible" mobileOnly={false}>
          <ul className="flex md:block mr-3 md:mr-0 min-w-max">
            {links.map((link) => (
              <li key={link.to} className={`mr-0.5 md:mr-0 md:mb-0.5 ${link.separated ? 'md:mt-2 md:pt-2 md:border-t border-[var(--admin-border)] ml-1.5 md:ml-0 pl-1.5 md:pl-0 border-l md:border-l-0' : ''}`}>
                <NavLink
                  end
                  to={link.to}
                  className={`flex items-center px-2.5 py-2 rounded-lg whitespace-nowrap transition-all duration-200 ${
                    pathname.includes(link.match)
                      ? 'bg-[var(--admin-accent-light)] text-[var(--admin-accent)] ring-1 ring-inset ring-[var(--admin-accent)]'
                      : 'gch-text-primary hover:bg-white/5 hover:gch-text-primary'
                  }`}
                >
                  <span className="text-sm font-semibold">{link.label}</span>
                </NavLink>
              </li>
            ))}
          </ul>
      </ScrollableTabBar>
    </div>
  );
}

export default SettingsSidebar;
